var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visa",
    xmlns: "http://www.w3.org/2000/svg",
    width: 780,
    height: 500,
    viewBox: "0 0 780 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_771",
    "data-name": "Rectangle 771",
    width: 780,
    height: 500,
    rx: 38,
    fill: "#0e4595"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_54956",
    "data-name": "Path 54956",
    d: "M293.2,348.73l33.361-195.76h53.36L346.536,348.73ZM539.31,157.19a137.805,137.805,0,0,0-47.822-8.222c-52.725,0-89.865,26.55-90.18,64.6-.3,28.13,26.514,43.822,46.752,53.186,20.771,9.6,27.752,15.714,27.654,24.283-.131,13.121-16.586,19.116-31.922,19.116-21.357,0-32.7-2.967-50.227-10.276l-6.876-3.11L379.2,340.593c12.463,5.464,35.51,10.2,59.438,10.443,56.09,0,92.5-26.246,92.916-66.882.2-22.269-14.016-39.216-44.8-53.188-18.65-9.055-30.072-15.1-29.951-24.268,0-8.137,9.668-16.839,30.557-16.839a98.476,98.476,0,0,1,39.938,7.5l4.781,2.26,7.232-42.429m137.31-4.223H635.388c-12.773,0-22.332,3.487-27.941,16.234L528.2,348.6h56.031s9.16-24.123,11.232-29.418c6.125,0,60.555.084,68.338.084,1.6,6.853,6.49,29.334,6.49,29.334h49.514L676.62,152.961ZM611.2,279.377c4.412-11.279,21.26-54.723,21.26-54.723-.316.522,4.379-11.334,7.074-18.684l3.6,16.879s10.219,46.729,12.354,56.528ZM247.9,152.967l-52.24,133.5-5.567-27.13c-9.725-31.273-40.025-65.155-73.9-82.118l47.766,171.2,56.456-.064,84-195.39H247.9",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_54957",
    "data-name": "Path 54957",
    d: "M146.92,152.96H60.879l-.681,4.073c66.938,16.2,111.23,55.363,129.62,102.41l-18.71-89.96c-3.23-12.4-12.6-16.094-24.186-16.527",
    fill: "#f2ae14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.d1ac994ae183e3781780fc095fa57d34.svg";
export { ForwardRef as ReactComponent };